import type {
  ForwardStatusResponse,
  ForwardTableStatus,
} from "@/apis/forward/types";

/**
 * 표 단위 forward 진행 판정. 폴링 종료 조건이라 훅·컴포넌트 양쪽이 같은 답을 써야 해
 * 순수 함수로 분리해 둔다(무거운 import 없이 테스트 가능하게).
 */

/** 태스크가 한 번이라도 생성된 표인지. status null은 미실행 표다. */
export const hasForwardRecord = (table: ForwardTableStatus) =>
  table.status !== null;

export const isForwardRunning = (table: ForwardTableStatus) => {
  if (table.status === "PENDING" || table.status === "RUNNING") return true;
  // 스마트 롤포워드 체인: 이월은 끝났지만 이어진 오토태깅이 아직 끝나지 않은 표.
  if (table.outcome !== "AUTO_ENQUEUED") return false;
  // autoStatus 가 없으면(null/undefined) 진행 중으로 보지 않는다. 오토태깅 상태 행은
  // forward outcome 보다 먼저 커밋되므로, AUTO_ENQUEUED 를 받은 시점에 행이 없다면
  // 첫 폴링 전 과도기가 아니라 태스크가 유실된 상태다. 진행 중으로 두면 폴링이 영영
  // 안 멈추고, 완료 처리(캐시 무효화·완료 토스트)까지 막혀 이월된 태그가 시트에
  // 반영되지 않는다. 이 표는 "확인" 상태로 표시된다(constants 의 NOT_STARTED 매핑).
  return table.autoStatus === "PENDING" || table.autoStatus === "RUNNING";
};

/** 폴링 중단 조건: 진행 중인 표가 하나도 없으면 종료. */
export const checkForwardFinished = (data: ForwardStatusResponse) =>
  !data.tables.some(isForwardRunning);
